import { ResolveFn } from '@angular/router';
import { BaseInvoiceThemeModel } from '../../models/invoice/base-invoice-theme.model';
import {
  ContentArea,
  InvoiceDocumentDetailModel,
} from '../../models/invoice/invoice-document-detail.model';
import { InvoicePositionModel } from '../../models/finance/financial-record.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { invoiceDataResolver } from './invoice-data.resolver';

export const invoicePositionsResolver: ResolveFn<InvoicePositionModel[]> = (route, state) =>
  (invoiceDataResolver(route, state) as Observable<InvoiceDocumentDetailModel>).pipe(
    map((x: InvoiceDocumentDetailModel) => x.positions),
  );

export const invoiceThemePropsResolver: ResolveFn<BaseInvoiceThemeModel> = (route, state) =>
  (invoiceDataResolver(route, state) as Observable<InvoiceDocumentDetailModel>).pipe(
    map((x: InvoiceDocumentDetailModel) => x.themeProps),
  );

export const invoiceContentAreasResolver: ResolveFn<Map<string, ContentArea>> = (route, state) =>
  (invoiceDataResolver(route, state) as Observable<InvoiceDocumentDetailModel>).pipe(
    map((x: InvoiceDocumentDetailModel) => x.contentAreas),
  );
